import { theme } from '../legacyComponents/theme';

import { useMediaQuery } from './useMediaQuery';

export enum DeviceType {
  MobileS = 'mobileS',
  MobileM = 'mobileM',
  MobileL = 'mobileL',
  Tablet = 'tablet',
  Laptop = 'laptop',
  Desktop = 'desktop',
}

export function useDeviceType() {
  const { mobileS, mobileM, mobileL, tablet, laptop } = theme.breakpoints.values;
  const isMobileS = useMediaQuery({ max: mobileS });
  const isMobileM = useMediaQuery({ min: mobileS + 1, max: mobileM });
  const isMobileL = useMediaQuery({ min: mobileM + 1, max: mobileL });
  const isMobile = useMediaQuery({ min: mobileS + 1, max: tablet });
  const isTablet = useMediaQuery({ min: mobileL + 1, max: tablet });
  const isLaptop = useMediaQuery({ min: tablet + 1, max: laptop });
  const isDesktop = useMediaQuery({ min: laptop + 1 });

  return {
    isMobileS,
    isMobileM,
    isMobileL,
    isMobile,
    isTablet,
    isLaptop,
    isDesktop,
  };
}

export const useMaxDeviceWidth = (deviceType: DeviceType): boolean => {
  const breakpoint = theme.breakpoints.values[deviceType];

  return useMediaQuery({ max: breakpoint });
};

export const useMinDeviceWidth = (deviceType: DeviceType): boolean => {
  const breakpoint = theme.breakpoints.values[deviceType];

  return useMediaQuery({ min: breakpoint });
};
